import { REACT_APP_API_URL } from '../../setup/config'
import axios, { handleApiError } from '../axios'
 
 
export const searchPermActions = async (data) => { 
    try { 
        const response = await axios.post(`${REACT_APP_API_URL}/perm-action/search`, data)
        return response.data.data
    } catch (error) { 
        console.log("searchPermActions - error", error) 
        return handleApiError(error) 
    } 
} 